import { t } from "i18next";

import { Typography } from "@mui/material";

import ModalWrapper from "@/src/components/molecules/ModalWrapper";

interface DeleteDraftAuctionConfirmationModalProps {
  open: boolean;
  isDeleting: boolean;
  onClose: () => void;
  onConfirm: () => void;
}

const DeleteDraftAuctionConfirmationModal = ({
  open,
  isDeleting,
  onClose,
  onConfirm
}: DeleteDraftAuctionConfirmationModalProps) => (
  <ModalWrapper
    id="consumerHeaderDeleteAuctionModal"
    open={open}
    disableClose={isDeleting}
    onClose={() => !isDeleting && onClose()}
    title={t("myAuctions.removeAuctionModalTitle")}
    secondaryAction={{
      id: "cancelDeleteAuctionButton",
      label: t("general.cancel"),
      disabled: isDeleting,
      onClick: onClose
    }}
    primaryAction={{
      id: "confirmDeleteAuctionButton",
      label: t("general.delete"),
      loading: isDeleting,
      onClick: onConfirm
    }}
  >
    <Typography>{t("myAuctions.removeAuctionModalBody")}</Typography>
  </ModalWrapper>
);

export default DeleteDraftAuctionConfirmationModal;
